import { QueryResources } from 'datx-jsonapi-react';

import { Testimonial } from '@/resources/Testimonial';

export const queryTestimonials = (): QueryResources<Testimonial> => {
  return [
    Testimonial,
    {
      filter: {
        featured: 'true',
      },
      params: [
        {
          key: 'page[size]',
          value: '500',
        },
        {
          key: 'page[number]',
          value: '1',
        },
      ],
    },
  ];
};
